var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "app-header navbar"
  }, [_c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "Dashboard"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "navbar-toggler sidebar-toggler d-md-down-none",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.sidebarMinimize
    }
  }, [_vm._v("☰")]), _vm._v(" "), _c('b-nav', {
    staticClass: "ml-auto",
    staticStyle: {
      "margin-right": "1%"
    },
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.isMisrouteEnabled) ? _c('b-nav-item-dropdown', {
    staticClass: "custom-dropdown",
    staticStyle: {
      "left": "16px"
    }
  }, [_c('template', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [(_vm.notificationCount == 0) ? _c('span', {
    staticClass: "fa-stack NotifySpanCSS",
    attrs: {
      "title": "Notifications"
    },
    on: {
      "click": function($event) {
        _vm.checkIsNotificationOpen()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell fa-stack-1x fa-inverse NotifyIconCSS"
  })]) : _c('span', {
    staticClass: "fa-stack NotifySpanCSS",
    attrs: {
      "title": "Notifications",
      "data-count": _vm.notificationCount
    },
    on: {
      "click": function($event) {
        _vm.checkIsNotificationOpen()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell fa-stack-1x fa-inverse NotifyIconCSS"
  })])]), _vm._v(" "), (_vm.isNotify) ? [_c('div', {
    staticStyle: {
      "background-color": "lightgrey"
    }
  }, [_vm._v("\n            "), _c('label', {
    staticClass: "notifyLableCSS",
    attrs: {
      "for": "notifications"
    }
  }, [_vm._v("Notifications")])]), _vm._v(" "), _vm._l((_vm.notificationsList), function(item) {
    return _c('b-dropdown-item', {
      key: item.value,
      staticStyle: {
        "padding-left": "10px",
        "color": "orangered"
      },
      on: {
        "click": function($event) {
          _vm.goToNotificationUrl(item)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  })] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "onHover",
    staticStyle: {
      "width": "135px",
      "padding": "5px"
    },
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [_c('basic-select', {
    class: {
      'form-control': true
    },
    staticStyle: {
      "width": "135px",
      "background-color": "#20a8d8"
    },
    attrs: {
      "options": _vm.hubaccessObjArray,
      "selected-option": _vm.hubObj,
      "name": "ChangeHub",
      "placeholder": "CHANGE HUB"
    },
    on: {
      "select": _vm.changeHubTodefaultHub
    }
  })], 1)], 2), _vm._v(" "), _c('b-nav-item-dropdown', {
    staticClass: "custom-dropdown"
  }, [_c('template', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [_c('span', {
    staticClass: "dropdown-toggle",
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    staticStyle: {
      "font-size": "22px",
      "color": "red",
      "padding-left": "10px"
    }
  }), _vm._v(" " + _vm._s(_vm.currentHubName) + " ")])])], 2), _vm._v(" "), _c('b-nav-item-dropdown', {
    attrs: {
      "right": ""
    }
  }, [_c('template', {
    attrs: {
      "slot": "button-content"
    },
    slot: "button-content"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/default-img.png",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "d-md-down-none",
    staticStyle: {
      "color": "#fff !important"
    }
  }, [_vm._v(_vm._s(_vm.username)), _c('i', {
    staticClass: "fa fa-caret-down custom-caret"
  })])]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": function($event) {
        _vm.editProfile()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Profile")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.changepassword
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" Change Password")]), _vm._v(" "), _c('b-dropdown-item', {
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" Logout")])], 2)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63c78490","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 538
// module chunks = 1